import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  SecondaryButton,
  PrimaryButton,
  TextInput,
  SelectBoxForAuth,
  SelectBox,
} from '../components/UIkit'
import {
  getUsername,
  getUserInfo,
  getUserRole,
} from '../reducks/users/selectors'
import { push } from 'connected-react-router'
import {
  Checkbox,
  FormControlLabel,
  makeStyles,
  Switch,
  Typography,
} from '@material-ui/core'
import LanguageIcon from '@mui/icons-material/Language'
import SelectWorker from '../components/User/SelectWorker'
import { updateUser, updateUserInfo } from '../reducks/users/operations'
import { PERMISSIONS } from '../constants/permissions'
import { getDepartments } from '../reducks/department/selectors'
import { fetchdepartments } from '../reducks/department/operations'
import { updateProfileAction } from '../reducks/users/actions'
import SelectEmail from '../components/User/SelectEmail'
import SelectBoxForFilter from '../components/UIkit/SelectBoxForFilter'
import { timeTable, weekDays } from '../constants/initialSendMail'
import SelectOrderEmail from '../components/User/SelectOrderEmail'

const useStyle = makeStyles((theme) => ({
  userNumber: {
    display: 'flex',
    alignItems: 'center',
  },
  languageButton: {
    marginTop: '20px',
    width: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#757575',
  },
  selectBox: {
    marginBottom: '-10px',
  },
  switch: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 40px 0 0',
  },
  sendTime: {
    width: '80px',
  },
  textInput: {
    padding: '0 10px',
  },
  switchBase: {
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {}, // checkedの状態に必要な空クラス
  track: {
    '$checked + &': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checkbox: {
    color: '#757575', // uncheckedの色を指定
    '&.Mui-checked': {
      color: '#4dd0e1', // checkedの色を指定
    },
  },
  label: {
    fontSize: '14px', // ラベルのフォントサイズを変更
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  weekDayLabel: {
    marginRight: '10px',
  },
  sendMail: {
    marginTop: '20px',
  },
  sendDays: {
    margin: '0 10px',
  },
}))

const roles = [
  { id: PERMISSIONS.NORMAL_USER, name: PERMISSIONS.NORMAL_USER },
  {
    id: PERMISSIONS.HUMAN_RESOURCE_USER,
    name: PERMISSIONS.HUMAN_RESOURCE_USER,
  },
  { id: PERMISSIONS.ADMINISTRATOR, name: PERMISSIONS.ADMINISTRATOR },
  { id: PERMISSIONS.VIEWER, name: PERMISSIONS.VIEWER },
]

const UserMyPage = () => {
  const dispatch = useDispatch()
  const classes = useStyle()
  //const selector = useSelector((state) => state);
  //const username = getUsername(selector);
  const userInfo = useSelector(getUserInfo)
  const userRole = useSelector(getUserRole)
  const isAdministrator =
    userRole === PERMISSIONS.HUMAN_RESOURCE_USER ||
    userRole === PERMISSIONS.ADMINISTRATOR
  const [showSelectEmail, setShowSelectEmail] = useState(false)
  const [usernumber, setUsernumber] = useState(userInfo.usernumber),
    [username, setUsername] = useState(userInfo.username),
    [userdepnumber, setUserdepnumber] = useState(userInfo.departmentid),
    [userdepname, setUserdepname] = useState(userInfo.departmentname),
    [userauth, setUserauth] = useState(userInfo.role),
    [userid, setUserid] = useState(userInfo.uid),
    [showSelectUser, setShowSelectUser] = useState(false),
    [email, setEmail] = useState(userInfo.email),
    [role, setRole] = useState(userInfo.role),
    [orderBaseId, setOorderBaseId] = useState(userInfo.order_base_id),
    [orderBaseName, setOrderBaseName] = useState(userInfo.order_base_name),
    [orderDepId, setOrderDepId] = useState(userInfo.order_department_id),
    [orderDepName, setOrderDepName] = useState(userInfo.order_department_name),
    [orderEmail, setOrderEmail] = useState(userInfo.order_email),
    [isSend, setIsSend] = useState(userInfo.isSend),
    [sendTime, setSendTime] = useState(userInfo.sendTime),
    [days, setDays] = useState(userInfo.days),
    [sign, setSign] = useState(userInfo.sign)
  const departmentsOnFirestore = useSelector(getDepartments)
  const [departments, setDepartments] = useState([])
  useEffect(() => {
    dispatch(fetchdepartments())
  }, [dispatch])
  useEffect(() => {
    const departmentList = departmentsOnFirestore.map((department) => {
      return {
        order_department_id: department.did,
        order_department_name: department.name,
        order_base_id: department.base_id,
        order_base_name: department.base_name,
        name: department.base_name + ' ' + department.name,
        id: department.did,
      }
    })
    setDepartments(departmentList)
  }, [departmentsOnFirestore])
  // useEffect(() => {
  //   console.log(userInfo, "userInfo");
  // }, [userInfo]);

  useEffect(() => {
    setUsernumber(userInfo.usernumber)
    setUsername(userInfo.username)
    setUserdepnumber(userInfo.departmentid)
    setUserdepname(userInfo.departmentname)
    setUserauth(userInfo.role)
    setUserid(userInfo.uid)
    setEmail(userInfo.email)
    setRole(userInfo.role)
    setOrderEmail(userInfo.order_email)
    setSign(userInfo.sign)
    setOrderDepId(userInfo.order_department_id)
    setOrderDepName(userInfo.order_department_name)
    setOorderBaseId(userInfo.order_base_id)
    setOrderBaseName(userInfo.order_base_name)
    setIsSend(userInfo.isSend)
    setSendTime(userInfo.sendTime)
    setDays(userInfo.days)
  }, [userInfo])
  //メモ化
  const inputUsernumber = useCallback(
    (event) => {
      // setUsernumber(event.target.value);
    },
    [setUsernumber]
  )
  const inputUsername = useCallback(
    (event) => {
      // setUsername(event.target.value);
    },
    [setUsername]
  )
  const inputUserdepname = useCallback(
    (event) => {
      setUserdepname(event.target.value)
    },
    [setUserdepname]
  )
  const inputUserauth = useCallback(
    (value) => {
      setUserauth(value)
    },
    [setUserauth]
  )
  const inputEmail = useCallback(
    (event) => {
      setEmail(event.target.value)
    },
    [setEmail]
  )
  const inputOrderEmail = useCallback(
    (event) => {
      setOrderEmail(event.target.value)
    },
    [setOrderEmail]
  )
  const inputSign = useCallback(
    (event) => {
      setSign(event.target.value)
    },
    [setSign]
  )

  const handleLanguageButtonClick = () => {
    setShowSelectUser(true)
  }
  const handleEmailButtonClick = () => {
    setShowSelectEmail(true)
  }
  const transition = useCallback((path) => {
    dispatch(push(path))
  }, [])
  const inputOrderDepartmentInfo = useCallback(
    (value) => {
      setOrderDepId(value)
      setOrderDepName(
        departments.find((department) => department.id === value)
          .order_department_name
      )
      setOorderBaseId(
        departments.find((department) => department.id === value).order_base_id
      )
      setOrderBaseName(
        departments.find((department) => department.id === value)
          .order_base_name
      )
    },
    [setOrderDepId, setOrderDepName, departments]
  )

  return (
    <section className="c-section-container">
      <h2 className="u-text__headline u-text-center">マイページ</h2>
      <div className="module-spacer--medium" />
      <div className={classes.userNumber}>
        <TextInput
          fullWidth={true}
          label={'ユーザー情報'}
          multiline={false}
          required={true}
          minRows={1}
          value={username + ' ' + userdepname}
          type={'text'}
          disabled={false}
          onChange={inputUsername}
        />
        <button
          className={classes.languageButton}
          onClick={handleLanguageButtonClick}
        >
          <LanguageIcon />
        </button>
      </div>
      {/* <TextInput
        fullWidth={true}
        label={"名前"}
        multiline={false}
        required={true}
        minRows={1}
        value={username}
        type={"text"}
        disabled={true}
        onChange={inputUsername}
      /> */}
      <div style={{ height: '10px' }}></div>
      <div className={classes.selectBox}>
        <SelectBox
          label={'発注部署'}
          options={departments}
          required={true}
          select={inputOrderDepartmentInfo}
          value={orderDepId}
        />
      </div>
      <div className={classes.userNumber}>
        <TextInput
          fullWidth={true}
          label={'発注担当者メールアドレス'}
          multiline={false}
          required={true}
          readOnly={true}
          minRows={1}
          value={orderEmail}
          type={'email'}
          onChange={inputOrderEmail}
        />
        <button
          className={classes.languageButton}
          onClick={handleEmailButtonClick}
        >
          <LanguageIcon />
        </button>
      </div>
      <div style={{ height: '20px' }}></div>
      <div className={classes.textInput}>
        <TextInput
          fullWidth={true}
          label={'メールアドレス'}
          multiline={false}
          required={true}
          minRows={1}
          value={userInfo.email}
          type={'email'}
          disabled={true}
          onChange={inputEmail}
        />
      </div>
      {/* <div style={{ color: "red", fontSize: 14 }}>emailは変更できません</div> */}
      <TextInput
        fullWidth={true}
        label={'権限'}
        multiline={false}
        required={true}
        minRows={1}
        value={userauth}
        type={'text'}
        disabled={true}
        onChange={inputUserauth}
      />
      <TextInput
        fullWidth={true}
        label={'メール署名'}
        multiline={true}
        required={true}
        rows={5}
        value={sign}
        type={'text'}
        disabled={false}
        onChange={inputSign}
        placeholder={'発注メール送信時の署名を入力してください'}
      />
      <div className={classes.sendMail}>
        <p className={classes.noticeTitle}>通知設定</p>
        <div className={classes.switch}>
          <FormControlLabel
            label={
              <Typography className={classes.label}>
                {isSend ? '通知する' : '通知しない'}
              </Typography>
            }
            labelPlacement="start"
            control={
              <Switch
                checked={isSend}
                onChange={(e) => setIsSend(e.target.checked)}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.checked,
                  track: classes.track,
                }}
              />
            }
          />
          <div className={classes.sendTime}>
            <SelectBoxForFilter
              label={'通知時刻'}
              options={timeTable()}
              required={true}
              select={(value) => setSendTime(value)}
              value={sendTime}
              width={'100px'}
              height={'30px'}
              fontSize={'16px'}
              disabled={!isSend}
            />
          </div>
        </div>
        <p className={classes.sendDays}>通知日</p>
        <div className={classes.checkboxes}>
          {days.map((day, index) => (
            <FormControlLabel
              label={
                <Typography className={classes.weekDayLabel}>
                  {weekDays[index]}
                </Typography>
              }
              labelPlacement="start"
              control={
                <Checkbox
                  classes={{ root: classes.checkbox }}
                  edge="start"
                  checked={days[index].isSend}
                  tabIndex={-1}
                  disableRipple
                  onChange={(e) => {
                    const newDays = [...days]
                    newDays[index].isSend = e.target.checked
                    setDays(newDays)
                  }}
                  inputProps={{
                    'aria-label': 'Select all rows on current page',
                  }}
                  disabled={!isSend}
                />
              }
              key={index}
            />
          ))}
        </div>
      </div>
      <div className="module-spacer--medium" />
      <div className="module-spacer--medium" />
      <div className="center">
        <PrimaryButton
          label={'ユーザー情報を更新する'}
          onClick={async () => {
            const result = await dispatch(
              updateUser(
                userid,
                username,
                userInfo.email,
                usernumber,
                userdepnumber,
                userdepname,
                orderBaseId,
                orderBaseName,
                orderDepId,
                orderDepName,
                role,
                orderEmail,
                sign,
                isSend,
                sendTime,
                days,
                true
              )
            )
            if (result) {
              dispatch(
                updateProfileAction({
                  usernumber: usernumber,
                  username: username,
                  departmentid: userdepnumber,
                  departmentname: userdepname,
                  role: role,
                  uid: userid,
                  order_base_id: orderBaseId,
                  order_base_name: orderBaseName,
                  order_department_id: orderDepId,
                  order_department_name: orderDepName,
                  email: userInfo.email,
                  order_email: orderEmail,
                })
              )
              dispatch(push('/'))
            }
          }}
        />
      </div>

      {/* <TextDetail label="ユーザー名" value={username} /> */}
      {/* <div className="module-spacer--small" /> */}
      <div className="center">
        {/* <SecondaryButton label={"カード情報の編集"} onClick={() => transition('/user/payment/edit')} /> */}
        <SecondaryButton
          label={'注文履歴の確認'}
          onClick={() => transition('/order/history')}
        />
      </div>
      {showSelectUser && (
        <SelectWorker
          username={username}
          setUsername={setUsername}
          usernumber={usernumber}
          setUsernumber={setUsernumber}
          userdepnumber={userdepnumber}
          setUserdepnumber={setUserdepnumber}
          userdepname={userdepname}
          setUserdepname={setUserdepname}
          setShowSelectUser={setShowSelectUser}
          email={email}
          setEmail={setEmail}
        />
      )}
      {showSelectEmail && (
        <SelectOrderEmail
          email={orderEmail}
          setEmail={setOrderEmail}
          setShowSelectEmail={setShowSelectEmail}
        />
      )}
    </section>
  )
}

export default UserMyPage
